import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import './CardUpdate.css';

export const CardUpdate = ({cardId, updateComplete, token}) => {
  const params = useParams();
  const [cardName, setCardName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    console.log('in card update');
    console.log(cardId);
    if (!window.document.getElementById('stripe-script')) {
      var s = window.document.createElement("script");
      s.id = "stripe-script";
      s.type = "text/javascript";
      s.src = "https://js.stripe.com/v3/";
      s.onload = () => {
        const style = {
          base: {
            // Add your base input styles here. For example:
            fontSize: '14px',
            color: '#32325d',
            '::placeholder': {
              color: '#999999'
            },
            border: '2px solid black',
          },
        };
        const expiryStyle = {
          base: {
            // Add your base input styles here. For example:
            fontSize: '14px',
            '::placeholder': {
                color: '#999999'
            },
          }
        };

        window.stripeObj = window['Stripe'](`${process.env.REACT_APP_STRIPE_KEY}`);
        window.elements = window.stripeObj.elements();
        window.cardNumber = window.elements.create('cardNumber', {
            style: style,
            placeholder: 'Card number'
        });
        window.cardNumber.mount('#cardNumber');

        window.cardExpiry = window.elements.create('cardExpiry', {
           style: expiryStyle,
           placeholder: 'Expiration date (MM/YY)'
        });
        window.cardExpiry.mount('#expirationDate');

        window.cardCvc = window.elements.create('cardCvc', {
            style: expiryStyle,
            placeholder: 'Security code'
        });
        window.cardCvc.mount('#securityCode');

      }
      window.document.body.appendChild(s);
    }

  }, []);

  const nameChange = (event) => {
    setCardName(event.target.value);
  };

  const updateCard = async (stripeToken) => {
    const response = await fetch('/customercardupdate', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify({code: params.code, card_id: cardId, token: stripeToken})
    });
    const data = await response.json();
    if (data.ok) {
        updateComplete();
    } else if (data.error) {
        setErrorMessage(data.error);
    }
  }

  const updateCardClick = () => {
    var additionalData = {
        name: cardName
    }
    window.stripeObj.createToken(window.cardNumber, additionalData).then((result) => {
        console.log(result)
        if (result.token) {
          updateCard(result.token.id);
        }
    });
  };

  return (
    <div className="cardUpdateContentInner">
            <form method="POST" id="cardUpdateForm">
                <div className="cardUpdateForm">
                    <div className="cardUpdateLogos">
                        <img alt="Visa" src="/images/signup/icon_visa.svg"/>
                        <img alt="Master Card" src="/images/signup/icon_mc.svg"/>
                        <img alt="American Express" src="/images/signup/icon_amx.svg"/>
                        <img alt="Discovery" src="/images/signup/icon_disc.svg"/>
                    </div>
                        <div className="cardUpdateCardNumberRow" >
                            <div className="cardUpdateCardNumber" >
                                <div id="cardUpdateCardNumberLabel" className="cardUpdateCardNumberLabel" >
                                Card number
                                </div>
                                <div className="cardUpdateCardNumberEntry" id="cardNumber" ></div>
                            </div>
                        </div>
                    <div className="cardUpdateCardError">
                    {errorMessage}
                    </div>
                        <div className="cardUpdateCardNameRow" >
                            <div className="cardUpdateCardName" >
                                <div id="cardUpdateCardNameLabel" className="cardUpdateCardNameLabel" >
                                Name on card
                                </div>
                                <input id="cardName" type="text" className="cardUpdateCardNameEntry"  placeholder="Name on card" onChange={nameChange} value={cardName}/>
                            </div>
                        </div>
                        <div className="cardUpdateCardExpirationRow" >
                            <div className="cardUpdateCardExpiration" >
                                <div id="cardUpdateCardExpirationLabel" className="cardUpdateCardExpirationLabel" >
                                Expiration date (MM/YY)
                                </div>
                                <div className="cardUpdateCardExpirationEntry" id="expirationDate" ></div>
                            </div>
                            <div className="cardUpdateCardSecurityCode" >
                                <div id="cardUpdateCardSecurityCodeLabel" className="cardUpdateCardSecurityCodeLabel" >
                                Security code
                                </div>
                                <div className="cardUpdateCardSecurityCodeEntry" id="securityCode" ></div>
                            </div>
                        </div>

                        <div className="cardUpdateSubmit" id="cardUpdateSubmit" onClick={updateCardClick}>
                            <div className="cardUpdateSubmitText">
                            Update
                            </div>
                        </div>

                </div>
            </form>

    </div>
  );
}
